import { render } from "./StateAbortMonument.vue?vue&type=template&id=53b75cf0"
import script from "./StateAbortMonument.vue?vue&type=script&lang=js"
export * from "./StateAbortMonument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__